export const roles = [
  {
    key: "USER",
    label: "Foydalanuvchi"
  },
  {
    key: "ADMIN",
    label: "Admin"
  },
  {
    key: "SUPER_ADMIN",
    label: "Super Admin"
  }
]